/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { Component } from 'react';
import { Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, Button } from 'react-bootstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Card from 'Admin/components/Card/Card.jsx';
import { updateInstructionAction } from 'Admin/actions/instruction';
import { languageListAction } from 'Admin/actions/language';

let Validator = require('validatorjs');
let formArr = {}
let rules = {
    instruction_english: 'required',

};
let mess = {
    required: 'This field is required.',

};
let validation = [];
validation = new Validator({}, rules, mess);
validation.passes();
validation.fails();

class UpdateInstruction extends Component {

    constructor(props) {
        super(props);

        this.state = {
            languageList: [],
            cardHidden: true,
            formArr: [],
            instruction_englishError: null,

            formData: {
                id: this.props.location.state.row._id,
                instruction_english: this.props.location.state.row.instruction.english,
                instruction: this.props.location.state.row.instruction
            },
            isLogin: true,
            showProcessing: false,
            limitForm: {},
        }
    }

    componentDidMount() {
        let data = this.state.limitForm;
        data['limitStatus'] = true;
        this.props.languageListAction(data);

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isLanguageList !== this.props.isLanguageList) {
            this.setState({ languageList: nextProps.LanguageList.data });
        }

        if (nextProps.isUpdateInstructionError !== this.props.isUpdateInstructionError) {
            if (nextProps.msg.errors) {
                nextProps.msg.errors.map((key, i) => {
                    this.setState({ [(key.param) + "Error"]: <small className="text-danger">{key.msg}</small> })
                });
            }
        }


        if (nextProps.isUpdateInstruction !== this.props.isUpdateInstruction) {
            this.props.handleClick('success', nextProps.UpdateInstruction.msg)
            this.props.history.push('/admin/instruction')
        }
    }

    handleChange(e, language) {
        e.preventDefault();
        let field = this.state.formData;
        field.instruction[language] = e.target.value;
        field[e.target.name] = e.target.value;
        this.setState({ formData: field });
    }




    allValidate(check) {
        if (!check) {
            formArr = []
            Object.keys(rules).forEach(function (key) {
                formArr[key] = "TT";
            });
            this.setState({
                formArr
            });
        }
        if (validation.passes()) {
            return 1;
        }
    }

    updateInstruction(evt) {
        evt.preventDefault();
        const _this = this;

        if (this.allValidate(false)) {
            let field = this.state.formData;

            _this.setState({ showProcessing: true });
            _this.props.updateInstructionAction(field);
        }
        //validation.errors()
    }

    goBackFun(e) {
        this.props.history.replace(sessionStorage.getItem("prvUrl"))
    }

    render() {

        validation = new Validator(this.state.formData, rules, mess);
        validation.passes();
        validation.fails();
        let _this = this;
        return (
            <div className="main-content" style={{ padding: '15px 0px' }}>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title={<legend className="line-removes">
                                    <Button className="go-back-btn-1" bsStyle="info" onClick={(e) => { this.goBackFun(e) }}>Back</Button>
                                </legend>}
                                content={
                                    <Form horizontal>

                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={2} smOffset={2}>
                                                Name  <span className="star">*</span>
                                            </Col>
                                            <Col sm={6} className="spcc">

                                                {this.state.languageList.map(function (lang) {
                                                    return <FormControl className="spc-in" type="text" name={'instruction_' + lang.name} id={'instruction_' + lang.name} placeholder={lang.placeholder} value={_this.state.formData.instruction[lang.name]} onChange={(event) => { _this.handleChange(event, lang.name) }} />
                                                })}
                                                <span className="errorMsg">
                                                    {this.state.instruction_englishError}
                                                    {this.state.formArr.instruction_english && validation.errors.first('instruction_english')}</span>
                                            </Col>
                                        </FormGroup>



                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={2} smOffset={2}></Col>
                                            <Col sm={6}>
                                                <button type="button" onClick={this.updateInstruction.bind(this)} className="btn-fill btn-wd btn btn-info">Save</button>&nbsp;
                                            </Col>
                                        </FormGroup>
                                    </Form>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
        msg: state.instruction.message,

        UpdateInstruction: state.instruction.UpdateInstruction,
        isUpdateInstruction: state.instruction.isUpdateInstruction,
        isUpdateInstructionError: state.instruction.isUpdateInstructionError,

        LanguageList: state.language.LanguageList,
        isLanguageList: state.language.isLanguageList,
        isLanguageListError: state.language.isLanguageListError,

    }
}
export default withRouter(connect(mapStateToProps, { updateInstructionAction, languageListAction })(UpdateInstruction));
